module.exports = __webpack_public_path__ + "media/images/lp_thanks-17cfb825295ab10f6124a62cf309d192.webp";